import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getCurrentSupportedApiVersions, validateDomainAndGetStoreUrl, validateApiVersion, createGraphQLClient, generateGetHeaders, generateGetGQLClientParams } from '@shopify/graphql-client';
import { CLIENT, DEFAULT_CONTENT_TYPE, SDK_VARIANT_HEADER, DEFAULT_SDK_VARIANT, SDK_VERSION_HEADER, DEFAULT_CLIENT_VERSION, SDK_VARIANT_SOURCE_HEADER, PUBLIC_ACCESS_TOKEN_HEADER, PRIVATE_ACCESS_TOKEN_HEADER } from './constants.mjs';
import { validateRequiredAccessTokens, validatePrivateAccessTokenUsage } from './validations.mjs';

function createStorefrontApiClient(_ref) {
  var _objectSpread2;

  var storeDomain = _ref.storeDomain,
      apiVersion = _ref.apiVersion,
      publicAccessToken = _ref.publicAccessToken,
      privateAccessToken = _ref.privateAccessToken,
      clientName = _ref.clientName,
      _ref$retries = _ref.retries,
      retries = _ref$retries === void 0 ? 0 : _ref$retries,
      customFetchApi = _ref.customFetchApi,
      logger = _ref.logger;
  var currentSupportedApiVersions = getCurrentSupportedApiVersions();
  var storeUrl = validateDomainAndGetStoreUrl({
    client: CLIENT,
    storeDomain: storeDomain
  });
  var baseApiVersionValidationParams = {
    client: CLIENT,
    currentSupportedApiVersions: currentSupportedApiVersions,
    logger: logger
  };
  validateApiVersion(_objectSpread(_objectSpread({}, baseApiVersionValidationParams), {}, {
    apiVersion: apiVersion
  }));
  validateRequiredAccessTokens(publicAccessToken, privateAccessToken);
  validatePrivateAccessTokenUsage(privateAccessToken);
  var apiUrlFormatter = generateApiUrlFormatter(storeUrl, apiVersion, baseApiVersionValidationParams);

  var config = _objectSpread(_objectSpread({
    storeDomain: storeUrl,
    apiVersion: apiVersion
  }, publicAccessToken ? {
    publicAccessToken: publicAccessToken
  } : {
    privateAccessToken: privateAccessToken
  }), {}, {
    headers: _objectSpread(_objectSpread((_objectSpread2 = {
      'Content-Type': DEFAULT_CONTENT_TYPE,
      Accept: DEFAULT_CONTENT_TYPE
    }, _defineProperty(_objectSpread2, SDK_VARIANT_HEADER, DEFAULT_SDK_VARIANT), _defineProperty(_objectSpread2, SDK_VERSION_HEADER, DEFAULT_CLIENT_VERSION), _objectSpread2), clientName ? _defineProperty({}, SDK_VARIANT_SOURCE_HEADER, clientName) : {}), publicAccessToken ? _defineProperty({}, PUBLIC_ACCESS_TOKEN_HEADER, publicAccessToken) : _defineProperty({}, PRIVATE_ACCESS_TOKEN_HEADER, privateAccessToken)),
    apiUrl: apiUrlFormatter(),
    clientName: clientName
  });

  var graphqlClient = createGraphQLClient({
    headers: config.headers,
    url: config.apiUrl,
    retries: retries,
    customFetchApi: customFetchApi,
    logger: logger
  });
  var getHeaders = generateGetHeaders(config);
  var getApiUrl = generateGetApiUrl(config, apiUrlFormatter);
  var getGQLClientParams = generateGetGQLClientParams({
    getHeaders: getHeaders,
    getApiUrl: getApiUrl
  });
  var client = {
    config: config,
    getHeaders: getHeaders,
    getApiUrl: getApiUrl,
    fetch: function fetch() {
      return graphqlClient.fetch.apply(graphqlClient, _toConsumableArray(getGQLClientParams.apply(void 0, arguments)));
    },
    request: function request() {
      return graphqlClient.request.apply(graphqlClient, _toConsumableArray(getGQLClientParams.apply(void 0, arguments)));
    },
    requestStream: function requestStream() {
      return graphqlClient.requestStream.apply(graphqlClient, _toConsumableArray(getGQLClientParams.apply(void 0, arguments)));
    }
  };
  return Object.freeze(client);
}

function generateApiUrlFormatter(storeUrl, defaultApiVersion, baseApiVersionValidationParams) {
  return function (apiVersion) {
    if (apiVersion) {
      validateApiVersion(_objectSpread(_objectSpread({}, baseApiVersionValidationParams), {}, {
        apiVersion: apiVersion
      }));
    }

    var urlApiVersion = (apiVersion !== null && apiVersion !== void 0 ? apiVersion : defaultApiVersion).trim();
    return "".concat(storeUrl, "/api/").concat(urlApiVersion, "/graphql.json");
  };
}

function generateGetApiUrl(config, apiUrlFormatter) {
  return function (propApiVersion) {
    return propApiVersion ? apiUrlFormatter(propApiVersion) : config.apiUrl;
  };
}

export { createStorefrontApiClient };